import { tDispatch } from "../store";
import { eProActionTypes } from "./proTypes";

export const setProFToken = (token: string | null) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eProActionTypes.SET_CURRENT_F_TOKEN,
			payload: token
		})
	}
}

export const setProUToken = (token: string | null) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eProActionTypes.SET_CURRENT_U_TOKEN,
			payload: token
		})
	}
}

export const setProMaturityDate = (date:{ts: number, date: string} | null) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eProActionTypes.SET_CURRENT_MATURITY_DATE,
			payload: date
		})
	}
}

export const clearProState = () => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eProActionTypes.CLEAR_STATE,
		})
	}
}

export const setOptionsPeriodPro = (period: 'daily' | 'weekly') => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eProActionTypes.SET_OPTIONS_PERIOD,
			payload: period
		})
	}
}